import { render } from "./BsAlert.vue?vue&type=template&id=8edcc79e"
import script from "./BsAlert.vue?vue&type=script&lang=js"
export * from "./BsAlert.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__